import Common from '../../../Common';
import Port from './subscription/Port';
import Pricelist from './subscription/Pricelist';
import SIM from './subscription/SIM';

interface Body {
	name: string
	sim_id: id
	selfservice_pricelist_program_id?: id
	date?: string
	allowed_to_topup?: number | string
	pbx_user_id?: id
}

const Subscription = class extends Common {
	pricelist: InstanceType<typeof Pricelist>;
	port: InstanceType<typeof Port>;
	sim: InstanceType<typeof SIM>;

	constructor(headers: ApiHeaders) {
		super(headers)

		this.pricelist = new Pricelist(headers);
		this.port = new Port(headers);
		this.sim = new SIM(headers);
	}

	create = (companyId: id, data: Body) =>
		this.post(`/company/${companyId}/selfservice/subscription`, data);

	update = (companyId: id, subscriptionId: id, data: Body) =>
		this.patch(`/company/${companyId}/selfservice/subscription/${subscriptionId}`, data);

	browse = (companyId: id) =>
		this.get(`/company/${companyId}/selfservice/subscription`);
}

export default Subscription
